export default "__VITE_ASSET__V4$8WZNB__"